import { render, staticRenderFns } from "./FriendVolunteerCommonDetails.vue?vue&type=template&id=40048b7c"
import script from "./FriendVolunteerCommonDetails.vue?vue&type=script&lang=ts"
export * from "./FriendVolunteerCommonDetails.vue?vue&type=script&lang=ts"
import style0 from "./FriendVolunteerCommonDetails.vue?vue&type=style&index=0&id=40048b7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports